module.exports = __webpack_public_path__ + "media/images/jumping/promo-celebracion-section-57343f630f3b8ce2f2d6714f06db9d3a.png";